import axios from 'axios'
import { COMMISSIONS_ENDPOINT } from '../../endpoints'

export async function getStock(carlotId, saleType) {
    const response = await axios.get(`${COMMISSIONS_ENDPOINT}/getAllStocksIncentiveOpportunity?car_lot_id=${carlotId}&sale_type=${saleType}`)
    return response?.data?.data
}
